import { render, staticRenderFns } from "./fontStyleSet.vue?vue&type=template&id=3120e746&scoped=true"
import script from "./fontStyleSet.vue?vue&type=script&lang=js"
export * from "./fontStyleSet.vue?vue&type=script&lang=js"
import style0 from "./fontStyleSet.vue?vue&type=style&index=0&id=3120e746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120e746",
  null
  
)

export default component.exports